import { render, staticRenderFns } from "./PlaceMediaDelete.vue?vue&type=template&id=3b384f1a&scoped=true&"
import script from "./PlaceMediaDelete.vue?vue&type=script&lang=js&"
export * from "./PlaceMediaDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b384f1a",
  null
  
)

export default component.exports